import { useQuery } from '@tanstack/react-query';

import { appConfig } from '../../../appConfig';
import userFlow from '../flow/user/userFlow';
import { UserType } from '../flow/user/userModels';
import { userInfoSelectors } from '../selectors/userSelectors';
import { useAppSelector } from './useThunkDispatch';

export const hybrisUserQueryKeys = {
    all: ['hybrisUser'],
    user: () => [...hybrisUserQueryKeys.all, 'user'],
    municipal: () => [...hybrisUserQueryKeys.all, 'municipal'],
    type: () => [...hybrisUserQueryKeys.all, 'type'],
};

export const useHybrisUserInfoQuery = (noCache = false) => {
    const query = useQuery({
        queryFn: () => userFlow.getHybrisUserInfo(noCache),
        queryKey: [...hybrisUserQueryKeys.user(), noCache],
        staleTime: noCache ? 0 : 30 * 60 * 1000, // 30 minutes,
    });

    return query;
};

export const useHybrisMunicipalUserInfo = () => {
    const isShoppingForAnother = useAppSelector(userInfoSelectors.isShoppingForAnother);

    const query = useQuery({
        queryFn: () => userFlow.getHybrisMunicipalUserInfo(),
        queryKey: hybrisUserQueryKeys.municipal(),
        enabled: !!isShoppingForAnother,
        staleTime: 30 * 60 * 1000, // 30 minutes
    });

    return query;
};

const getInitialUserType = () => {
    if (!appConfig.coopUserSettings.isAuthenticated) {
        return UserType.anonymous;
    }

    if (appConfig.coopUserSettings.punchout.isPunchout === true) {
        return UserType.punchout;
    }

    if (appConfig.coopUserSettings.isCompany) {
        return UserType.company;
    }

    return UserType.private;
};

export const useUserTypeQuery = () => {
    const query = useQuery({
        queryFn: () => userFlow.getUserType(),
        queryKey: hybrisUserQueryKeys.type(),
        initialData: getInitialUserType(),
    });

    return query;
};
